export default {
  女装: "ropa de mujer",
  男装: "de los hombres",
  手机和小工具: "Teléfonos móviles y gadgets.",
  居家生活: "vida hogareña",
  电脑及周边设备: "Computadoras y equipos periféricos.",
  美容及个人护理: "Belleza y cuidado personal",
  家用电器: "electrodomésticos",
  健康与保健: "salud y Bienestar",
  食品和饮料: "alimentos y bebidas",
  玩具_儿童和婴儿: "juguetes, niños y bebes",
  童装时尚: "moda infantil",
  视频游戏: "Juegos de vídeo",
  运动与户外: "Deportes y aire libre",
  爱好与书籍: "Pasatiempos y libros",
  相机和无人机: "Cámaras y drones",
  宠物食品及用品: "Alimentos y suministros para mascotas.",
  女士包袋: "bolsos de mujer",
  男士包袋: "bolsos de hombre",
  珠宝及配饰: "Joyas y Accesorios",
  手表: "mirar",
  女鞋: "zapatos de mujer",
  男装鞋: "zapatos de hombre",
  汽车: "auto",
  我附近的ShopeePay: "ShopeePay cerca de mí",
  餐饮_旅行和服务: "Catering, viajes y servicios.",
  旅行及行李: "Viajes y equipaje",
  各种各样的: "Diferentes tipos",
  我是来买什么的: "¿Qué estoy aquí para comprar?",
  对不起_找不到_相关的商品:
    "Lo sentimos, no se encontraron productos relacionados con [{0}]",
  类别: "categoría",
  产品: "producto",
  店铺: "comercio",
  首页: "página delantera",
  限时秒杀: "Venta flash por tiempo limitado",
  博客: "Blog",
  所有品牌: "Todas las marcas",
  所有类别: "Todas las categorias",
  我的购物车: "Mi carrito de compras",
  发货信息: "información de entrega",
  交货信息: "Información de entrega",
  付款: "Pago",
  确认: "confirmar",
  您的购物车是空的: "Su cesta está vacía",
  价格: "precio",
  税: "Impuesto",
  数量: "cantidad",
  总计: "total",
  移除: "Eliminar",
  返回商店: "Volver a la tienda",
  继续发货: "Continuar enviando",
  筛选: "filtrar",
  价格范围: "rango de precios",
  排序方式: "Ordenar por",
  最新: "A hoy",
  最旧: "más antiguo",
  价格从低到高: "Precio de menor a mayor",
  价格从高到低: "Precio de mayor a menor",
  选择交货类型: "Seleccione el tipo de entrega",
  送货上门: "Entrega",
  继续付款: "continuar pagando",
  任何其他信息: "Alguna otra información",
  或者: "o",
  您的钱包余额: "Saldo de tu billetera",
  余额不足: "Saldo insuficiente",
  支付: "pagar",
  我同意: "Estoy de acuerdo",
  条款和条件: "Términos y condiciones",
  退货政策: "política de devoluciones",
  隐私政策: "política de privacidad",
  概括: "generalizar",
  项目: "proyecto",
  全部的: "todo",
  小计: "Total parcial",
  总运费: "costo total de envío",
  有优惠码吗_在这里输入: "¿Existe un código de descuento? entre aquí",
  申请: "Aplicar",
  编辑: "editar",
  删除: "borrar",
  添加新地址: "agregar nueva dirección",
  继续交货信息: "Continuar información de entrega",
  选择一个地址: "Elige una dirección",
  购买历史: "Historial de compras",
  下载: "descargar",
  已发送退款请求: "Solicitud de reembolso enviada",
  对比: "Comparado",
  对话: "diálogo",
  我的钱包: "My bolso",
  工单: "orden de trabajo",
  管理个人资料: "Administrar perfil",
  登出: "desconectar",
  重置对比列表: "Restablecer lista de comparación",
  您的对比列表为空: "Tu lista de comparación está vacía",
  在您的购物车中: "en tu carrito de compras",
  在您的愿望清单中: "en tu lista de deseos",
  在您的预定列表中: "en tu lista de reservas",
  下载您的产品: "Descarga tu producto",
  选项: "Opciones",
  什么都没找到: "Nada Encontrado",
  特色产品: "Productos Destacados",
  最畅销: "Mejor vendido",
  前_名: "Arriba {0}",
  查看更多: "ver más",
  查看所有类别: "Ver todas las categorías",
  十大品牌: "Diez mejores marcas",
  查看所有品牌: "Ver todas las marcas",
  登录: "Acceso",
  手机号码: "número de teléfono",
  密码: "contraseña",
  密码长度为6到16个字符:
    "La longitud de la contraseña es de 6 a 16 caracteres.",
  验证码: "Código de verificación",
  登录中: "Acceso",
  游客登录: "Inicio de sesión de visitante",
  注册您的商店: "Registra tu tienda",
  现在申请: "Aplica ya",
  成为商家: "Conviértete en comerciante",
  现在注册: "Regístrate ahora",
  登录成功: "Aterrizó con éxito",
  通知: "notificar",
  未找到通知: "notificación no encontrada",
  评论: "Comentario",
  估计运输时间: "Tiempo estimado de envío",
  天: "cielo",
  所售: "vendido",
  给商家留言: "Deja un mensaje al comerciante",
  规格: "Especificación",
  库存: "en stock",
  总价: "precio total",
  添加到购物车: "añadir a la cesta",
  立即购买: "Compre ya",
  缺货: "Agotado",
  添加到愿望清单: "Añadir a la lista de deseos",
  加入对比列表: "Añadir a la lista de comparación",
  退款: "Reembolso",
  查看条款: "Mostrar Terminos",
  分享: "compartir",
  描述: "describir",
  相关产品: "Productos relacionados",
  没有人问过商家: "Nadie preguntó a los comerciantes.",
  该产品暂无评论: "Aún no hay reseñas para este producto.",
  客户评论: "Opiniones de los usuarios",
  访问商店: "visita la tienda",
  畅销产品: "Los más vendidos",
  日期: "fecha",
  订单编号: "número de orden",
  总额: "Suma global",
  状态: "estado",
  愿望清单: "lista de deseos",
  还没有添加任何东西: "Aún no se ha agregado nada",
  注册: "registro",
  邀请码: "Código de invitación",
  请输入邀请码: "Por favor ingresa el código de invitación",
  用户名: "nombre de usuario",
  请输入用户名: "por favor ingrese el nombre de usuario",
  用户名长度为6_14个字符:
    "La longitud del nombre de usuario es de 6 a 14 caracteres.",
  昵称: "Apodo",
  请输入手机号码: "Por favor ingrese el número de teléfono",
  手机号码格式错误: "Formato incorrecto del número de teléfono.",
  密码长度为6_16个字符: "La longitud de la contraseña es de 6 a 16 caracteres.",
  确认密码: "confirmar Contraseña",
  请输入确认密码: "Por favor ingrese la contraseña de confirmación",
  提款密码: "Contraseña de retiro",
  请输入提款密码: "Por favor ingrese la contraseña de retiro",
  提款密码长度为4_16个字符:
    "La longitud de la contraseña de retiro es de 4 a 16 caracteres",
  请输入验证码: "por favor ingrese el código de verificación",
  在_s后发送: "Enviado después de {0} s",
  发送验证码: "Enviar el código de verificación",
  注册即表示您同意我们的条款和条件:
    "Al registrarte aceptas nuestros términos y condiciones.",
  创建账号: "Crea una cuenta",
  验证码发送成功: "Código de verificación enviado exitosamente",
  确认密码不一致: "Confirme que la contraseña es inconsistente",
  提款密码必须为数字: "La contraseña de retiro debe ser numérica",
  注册成功: "registración exitosa",
  购物车: "carro de la compra",
  账户: "Cuenta",
  我的账户: "mi cuenta",
  已经有一个账户: "Ya tienes una cuenta",
  新地址: "nueva direccion",
  编辑地址: "Editar dirección",
  保存: "ahorrar",
  是否默认: "¿Es el valor predeterminado?",
  具体地址: "Dirección específica",
  请输入具体地址: "Por favor ingrese una dirección específica",
  地区: "área",
  请输入地区: "Por favor ingresa la región",
  城市: "Ciudad",
  请输入城市: "Por favor ingresa la ciudad",
  省份: "provincia",
  请输入省份: "Por favor ingresa provincia",
  邮政编码: "Código Postal",
  请输入邮政编码: "Por favor ingrese el código postal",
  电话号码: "número de teléfono",
  请输入电话号码: "Por favor, introduzca su número de teléfono",
  收货人: "Receptor",
  请输入收货人: "Por favor ingrese el destinatario",
  保存成功: "Guardado exitosamente",
  最畅销的商家: "Comerciantes más vendidos",
  查看所有的商家: "Ver todas las empresas",
  支持政策: "Política de soporte",
  您的电子邮件地址: "Su dirección de correo electrónico",
  订阅: "suscripción",
  联系方式: "Información del contacto",
  地址: "DIRECCIÓN",
  美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, EE.UU.",
  快速链接: "enlaces rápidos",
  商家政策: "Políticas comerciales",
  submit: "entregar",
  提款银行卡: "tarjeta bancaria de retiro",
  我的面板: "mi panel",
  提示: "pista",
  确定登出吗: "¿Está seguro de que desea cerrar sesión?",
  确定: "Seguro",
  取消: "Cancelar",
  项目添加到您的购物车: "Agregue el artículo a su carrito de compras",
  经常一起购买: "a menudo compran juntos",
  返回购物: "Volver a compras",
  进行结算: "pasar por la caja",
  帮助热线: "Línea de ayuda",
  查看所有通知: "Ver todas las notificaciones",
  请输入密码: "Por favor, ingrese contraseña",
  前往充值: "ir a recargar",
  购物车物品: "Artículos del carrito de compras",
  查看购物车: "revisa el carrito de compras",
  钱包余额: "saldo de billetera",
  充值钱包: "Recargar billetera",
  钱包充值_线下_: "Recarga de billetera (sin conexión)",
  申请提款: "Solicitar retiro",
  钱包收支明细: "Detalles de ingresos y gastos de Wallet",
  批准: "aprobar",
  提现历史记录: "Historial de retiros",
  类型: "tipo",
  信息: "información",
  付款方式: "método de pago",
  请选择付款方式: "Por favor elige un método de pago",
  Bill_Type_RECHARGE_BACK: "Recarga de backend",
  Bill_Type_RECHARGE_ONLINE: "Recarga en línea",
  Bill_Type_RECHARGE_REGISTER: "Registrate gratis",
  Bill_Type_RECHARGE_JACKPOT: "Bono de recarga",
  Bill_Type_RECHARGE_PRESENT: "Recargar recompensas",
  Bill_Type_RECHARGE_FROM_COMMISSION: "transferencia de comisión",
  Bill_Type_RECHARGE_TG_COMMISSION: "Comisión de promoción de recarga",
  Bill_Type_REGISTER_TG_COMMISSION: "Comisión de promoción de inscripciones.",
  Bill_Type_WITHDRAW: "retirar",
  Bill_Type_WITHDRAW_REJECT: "Retiro rechazado",
  Bill_Type_DEDUCT_HANDLE: "Deducción manual",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Corrección de recarga",
  Bill_Type_MINING_PROFIT: "Ingresos mineros",
  Bill_Type_MINING_PROFIT_COMMISSION:
    "Comisión de promoción de ingresos mineros",
  Bill_Type_VIP_UPGRADE: "Actualizar VIP",
  Bill_Type_FINANCE_BUY: "Comprar productos financieros",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Recuperación del equilibrio financiero",
  Bill_Type_FINANCE_FEE: "Honorarios de gestión financiera",
  Bill_Type_FINANCE_PROFIT: "Ingresos de gestión financiera",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Comisión por compra de productos financieros.",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Comisión de ingresos de productos financieros",
  Bill_Type_WHEEL_DRAW: "Lotería de la rueda grande",
  Bill_Type_BUY: "comprar bienes",
  Bill_Type_PAY_SHOP: "pagar el envío",
  Bill_Type_BUY_COMMISSION: "Comisión sobre artículos comprados.",
  Bill_Type_DEPOSIT: "Pagar deposito",
  Bill_Type_STORE_BUY: "comprar bienes",
  Bill_Type_STORE_BUY_REFUND: "Reembolso del producto de compra",
  Bill_Type: "Tipo de cambio de cuenta",
  Before_Money: "cantidad anterior",
  Deal_Money: "Monto del cambio de cuenta",
  After_Money: "cantidad después",
  Bill_Time: "hora de cambio de cuenta",
  No_More_Data: "no más datos",
  Apply_Money: "Monto de la solicitud",
  Apply_Time: "tiempo de aplicación",
  Withdraw_Info: "Tarifa de tramitación: {fee}, llegada: {money}",
  提款订单状态_CHECKING: "Revisión pendiente",
  提款订单状态_TRANSFERRING: "Transferencia",
  提款订单状态_PASS: "confirmado",
  提款订单状态_REJECT: "Despedido",
  暂无可用充值方式: "Aún no hay ningún método de recarga disponible",
  钱包收款码: "Código de pago de billetera",
  钱包地址: "dirección de billetera",
  金额限制: "límite de cantidad",
  复制: "Copiar",
  付款凭证: "comprobante de pago",
  收款银行: "Banco beneficiario",
  收款人: "Tenedor",
  收款账号: "número de cuenta de pago",
  付款银行: "banco de pago",
  付款人: "Pagador",
  付款账号: "Cuenta de pago",
  请输入付款银行: "Por favor ingrese el banco de pago",
  请输入付款人: "Por favor ingrese el pagador",
  请输入付款账号: "Por favor ingrese el número de cuenta de pago",
  请上传付款凭证: "Por favor cargue el comprobante de pago",
  充值金额: "Monto de recarga",
  请输入充值金额: "Por favor ingresa el monto de la recarga",
  submitting: "sumisión...",
  Confirm: "entregar",
  Commit_Success: "Enviado satisfactoriamente",
  balanceType_BALANCE: "balance",
  balanceType_COMMISSION: "comisión",
  Balance: "Saldo de la cuenta",
  Wash_Money: "agregar mosaico",
  请选择银行账户: "Por favor seleccione una cuenta bancaria",
  卡号类型: "Tipo de número de tarjeta",
  提现金额: "Cantidad de retiro",
  提款金额: "Cantidad de retiro",
  不能为空: "No puede estar vacío",
  金额不正确: "La cantidad es incorrecta",
  please_input_withdraw_password: "Por favor ingrese la contraseña de retiro",
  withdraw_password_format_error:
    "La contraseña de retiro debe tener entre 4 y 16 caracteres",
  Fee: "tasa de tramitación",
  实际到账: "Llegada real",
  交易币种: "Moeda de transação",
  原始密码: "contraseña original",
  confirm_password_error: "La contraseña ingresada dos veces es incorrecta",
  save_success: "Guardado exitosamente",
  please_input: "por favor escribe",
  old_password: "Contraseña anterior",
  new_password: "Nueva contraseña",
  please_input_confirm_password: "Por favor confirme la contraseña nuevamente",
  没有找到符合条件的商品: "No se encontraron productos coincidentes",
  Search: "buscar",
  全部: "todo",
  EnumGoodsOrderState_USER_PAY: "A la espera de la entrega",
  EnumGoodsOrderState_SHOP_PAY: "Entregando",
  EnumGoodsOrderState_SUCCESS: "Finalizar",
  EnumGoodsOrderState_CANCEL: "Cancelado",
  EnumGoodsOrderState_REFUND_SUCCESS: "reintegrado",
  订单号: "número de orden",
  用户名称: "nombre de usuario",
  收益: "ingreso",
  支付时间: "tiempo de pago",
  配送时间: "El tiempo de entrega",
  完成时间: "tiempo completo",
  发货: "Barco",
  全选: "seleccionar todo",
  物品已添加到愿望清单: "Artículo agregado a la lista de deseos",
  物品已添加到比较列表: "Artículo agregado a la lista de comparación",
  购买成功提示: "¡Enhorabuena, tu compra se ha realizado correctamente!",
  订单列表: "Lista de orden",
  商品名: "Nombre del producto",
  图片: "imagen",
  没有品牌: "sin marca",
  基本信息: "Información básica",
  Account_Name: "Nombre de lanombre cuenta",
  Bank_Account: "Cuenta bancaria",
  Bank_Phone: "Reservar número de teléfono móvil",
  IFSC: "cuenta IFSC",
  UPI: "cuenta UPI",
  PIX: "cuenta de foto",
  CPF: "cuenta CPF",
  GCASH: "cuenta GCASH",
  POWWI: "cuenta POWWI",
  身份证号: "número de identificación",
  Edit: "Revisar",
  Delete: "borrar",
  Add: "Nuevo",
  Forget_Withdraw_Password: "Olvidé la contraseña de retiro",
  Bank_Card_Info: "información de la tarjeta bancaria",
  收款人地址: "Dirección del beneficiario",
  SWIFT: "RÁPIDO",
  Bank_Branch: "Nombre de la sucursal",
  分行代码: "código de sucursal",
  银行地址: "Dirección del banco",
  Email: "Correo electrónico",
  银行卡长度必须超过:
    "La longitud de la tarjeta bancaria debe exceder {longitud}",
  银行卡格式不正确: "El formato de la tarjeta bancaria es incorrecto",
  Do_you_confirm_delete: "¿Confirmar la eliminación?",
  Please_Login_First: "por favor ingresa primero",
  Bank_Name: "Nombre del banco",
  Please_add_bank_first:
    "Aún no ha vinculado su tarjeta bancaria, agréguela primero",
  withdrawType: "Tipo de retiro",
  withdraw_money_limit:
    "El monto del retiro debe ser mayor que 0 y menor o igual a {saldo}",
  withdraw_times_limit:
    "Ha retirado {todayWithdrawNum} veces hoy y se le cobrará una tarifa de gestión del {withdrawFee}% después de {limitTimes} veces. ¿Estás seguro de retirarte?",
  Copy_Success: "Copiado exitosamente",
  商店首页: "Página de inicio de la tienda",
  所有产品: "Todos los productos",
  新到货产品: "Productos recién llegados",
  所有商家: "Todos los comerciantes",
  请上传: "Por favor sube",
  请输入: "por favor escribe",
  忘记密码: "olvida la contraseña",
  记得我: "Acuérdate de mí",
  共_件: "Total de {0} artículos",
  取消订单: "cancelar orden",
  申请退款: "Solicitar un reembolso",
  未知商家: "Comerciante desconocido",
  到账: "Recibo",
  提款订单状态: "Estado de la orden de retiro",
  前_名类别: "{0} categorías principales",
  取消订单原因_不想要了: "ya no lo quiero",
  取消订单原因_商品错选_多选:
    "Selección de producto incorrecta/múltiples selecciones",
  取消订单原因_商品无货: "Producto agotado",
  取消订单原因_地址信息填写错误:
    "La información de la dirección se completó incorrectamente",
  取消订单原因_商品降价: "Reducción del precio del producto.",
  取消订单原因_价格高于其他平台: "El precio es más alto que otras plataformas.",
  取消订单原因_没用_少用_错用优惠: "No uso/menos uso/mal uso de descuentos",
  退款原因_拍错_多拍_不喜欢: "Tiro equivocado / tiro extra / no me gusta",
  退款原因_商品成分描述不符:
    "La descripción del ingrediente del producto no coincide",
  退款原因_与商家协商一致退款: "Reembolso según lo acordado con el comerciante",
  退款原因_生产日期_保质期与商品描述不符:
    "La fecha de producción/vida útil no coincide con la descripción del producto.",
  退款原因_图片_产地_批号_规格等描述不符:
    "Las imágenes/origen de origen/número de lote/especificaciones y otras descripciones no coinciden",
  退款原因_质量问题: "Problemas de calidad",
  退款原因_商品变质_发霉_有异物:
    "El producto está estropeado/mohoso/tiene materias extrañas.",
  退款原因_少件_含缺少配件_:
    "Pocas piezas (incluidos los accesorios que faltan)",
  退款原因_收到商品时有破损_污渍_变形:
    "El artículo estaba dañado/manchado/deformado cuando se recibió.",
  退款原因_假冒品牌: "Marcas falsificadas",
  退款原因_发票问题: "Problemas con facturas",
  退款原因_商家发错货: "El comerciante envió la mercancía equivocada.",
  退款原因_预约不到_商家不给退换:
    "No puedo programar una cita/el comerciante no le dará un reembolso ni un cambio",
  退款失败: "Reembolso fallido",
  退款处理中: "Reembolso en curso",
  默认: "por defecto",
  产品查询: "Búsqueda de Producto",
  商店LOGO: "Logotipo de la tienda",
  推广码: "El código de promoción",
  查看所有: "ver todo",
  确认收货成功: "Confirmar la recepción de la mercancía con éxito.",
  物流公司: "Compañía de logísitca",
  物流单号: "numero de envío",
  发货时间: "Tiempo de envío",
  请先选择商品规格: "Seleccione primero las especificaciones del producto.",
  个人信息: "informacion personal",
  您的用户名: "su nombre de usuario",
  你的名字: "Su nombre",
  登录名: "nombre de usuario",
  你的邮件: "Tu correo electrónico",
  你的密码: "tu contraseña",
  重复输入密码: "Repita la contraseña",
  店铺名称: "Nombre de la tienda",
  证书类型: "Tipo de certificado",
  身份证: "tarjeta de identificación",
  护照: "pasaporte",
  驾驶执照: "Licencia de conducir",
  社会保障卡: "Tarjeta de seguro Social",
  证书正面: "Frente del certificado",
  证书反面: "Reverso del certificado",
  确认收货: "confirmar la recepción de mercancías",
  请选择取消订单的原因必选:
    "Por favor seleccione el motivo de la cancelación del pedido (obligatorio):",
  请选择申请退款的原因必选:
    "Seleccione el motivo por el que solicita un reembolso (obligatorio):",
  留言: "mensaje",
  请输入留言: "Por favor introduce un mensaje",
  没有帐户: "Sin cuenta",
  钱包充值: "Recarga de billetera",
  输入您的文字: "Introduce tu texto",
  商家登录: "Inicio de sesión de comerciante",
  有关此产品的任何查询: "Cualquier consulta sobre este producto",
  产品名称: "nombre del producto",
  你的问题: "tu problema",
  白银店铺: "tienda de plata",
  铂金店铺: "tienda platino",
  钻石店铺: "tienda de diamantes",
  照片: "foto",
  已退货: "Devuelto",
  邮寄状态: "Estado de envío",
  订单摘要: "Resumen del pedido",
  收件地址: "Dirección del receptor",
  订购日期: "Fecha de orden",
  订单状态: "Estado del pedido",
  总订单金额: "Monto total del pedido",
  邮寄方式: "método de envío",
  附加信息: "información adicional",
  订单详细信息: "Detalles del pedido",
  交货类型: "Tipo de entrega",
  进行评论: "Haz un comentario",
  已评论: "Comentado",
  订单金额: "Total de la orden",
  优惠券: "cupón",
  统一运费: "Tarifa de envío plana",
  送货地址: "Dirección de envío",
  评分: "puntaje",
  你的意见: "su opinión",
  匿名: "anónimo",
  现金: "dinero",
  详情: "Detalles",
  收货地址: "Dirección de envío",
  暂时没有对话: "Aún no hay conversación",
  你: "tú",
  输入您的回复: "Introduce tu respuesta",
  删除成功: "eliminado exitosamente",
  品牌: "marca",
  已缴纳的保证金: "Depósito de seguridad pagado",
  黄金店铺: "tienda de oro",
  没有更多数据: "no más datos",
  站内信: "Mensaje del sitio",
  系统通知: "notificación del sistema",
  邮箱: "Correo",
  手机号: "Número de teléfono",
  你的手机号: "su número de teléfono",
  营业执照: "licencia de negocios",
  你的邮箱: "tu buzón",
  搜索结果: "Resultados de la búsqueda",
  系统公告: "notificación del sistema",
  客服: "Servicio al Cliente",
  消息已撤回: "El mensaje ha sido retirado.",
  物流详情: "Detalles de logística",
  充值: "completar",
  提现: "retirar",
  信用分: "puntuación de crédito",
  余额: "Balance",
  佣金: "comisión",
  继续购物: "seguir comprando",
  订单结算: "Liquidación de pedidos",
  加入对比: "Añadir a comparación",
  佣金余额: "Saldo de comisiones",
  刷新: "Actualizar",
  刷新成功: "Actualizar exitosamente",
  税号: "RUT",
  官网: "Página web oficial",
  订单: "Orden",
  合计: "total",
  系统安全: "Seguridad del sistema",
  Recharge_Money_Limit: "El monto de la recarga debe estar entre {min} y {max}",
  限时优惠: "Oferta por tiempo limitado",
  高价回收: "Reciclaje a alto precio",
  姓名: "Nombre",
  商品订单号: "Número de pedido del producto",
  商品在线回收: "Reciclaje de productos en línea",
  提交: "entregar",
  回收记录: "Registros de reciclaje",
  回收状态: "Estado de reciclaje",
  回收价格: "precio del reciclaje",
  纳税码: "código fiscal",
  买家登录: "Acceso",
  买家注册: "registro",
  语言: "西班牙语",
  language: "Chino",
  助力提示:
    "Ayudar a los comerciantes puede aumentar la exposición de la plataforma a sus tiendas, y cuanto mayor sea el número acumulativo de días, mayor será la exposición.",
  已累计助力: "Asistido acumulativamente",
  今日已助力: "Hoy ha ayudado",
  立即助力: "Ayuda de inmediato",
  商家助力: "Ayuda comercial",
  证件号码: "Número de identificación",
  证书号码: "Número de certificado",
  男鞋: "Zapatos para hombres",
  游戏玩具: "Juguetes de juego",
  使用条款: "condiciones de uso",
  商家: "Comerciante",
  已助力: "Ha ayudado",
  被助力: "Ser ayudado",
  用户: "usuario",
  助力记录: "Ayuda registrar",
  消息类型: "Tipo de mensaje",
  消息内容: "Contenido de mensaje",
  链接: "Enlace",
  文本: "texto",
  清空: "Claro",
  评论成功: "Comentario exitoso",
  扫描二维码: "Escanea el código QR",
  转入: "transferencia en",
  收款: "Recopilación",
  任务下单中心: "centro de orden de tareas",
  记录: "grabar",
  任务倒计时: "Cuenta regresiva de tareas",
  倒计时后自动放弃:
    "Darse por vencido automáticamente después de la cuenta regresiva",
  业务码: "código comercial",
  选择商品分类: "Seleccionar categoría de producto",
  可多选: "Múltiples selecciones posibles",
  加载分类中: "Cargando categorías",
  暂无分类: "Aún no hay clasificación",
  产品类别: "Categoría de producto",
  账户余额: "Saldo de cuenta",
  立即结算: "Liquidación inmediata",
  任务已自动放弃: "La tarea ha sido abandonada automáticamente.",
  商品分类: "Clasificación de productos",
  订单详情: "Detalles del pedido",
  预计收益: "Ingresos estimados",
  预计佣金收益: "Ingresos estimados por comisiones",
  收益率: "Rendimiento",
  扣款账户: "cuenta de débito",
  确认结算: "Confirmar liquidación",
  未选择: "No seleccionado",
  请选择商品分类: "Por favor seleccione una categoría de producto",
  下单成功: "Pedido realizado con éxito",
  下单失败: "Orden fallida",
  请重试: "Por favor inténtalo de nuevo",
  订单记录: "Registro de pedido",
  没有更多了: "no más",
  业务号: "Número de negocio",
  商品类型: "tipo de producto",
  佣金收益: "ingresos por comisiones",
  待结算: "Pendiente de liquidación",
  已结算: "Resuelto",
  已取消: "Cancelado",
  加载失败: "Error al cargar",
  倒计时: "Cuenta atrás",
  随机商品: "elementos aleatorios",
  为: "para",
  商户助力可提升商品曝光度:
    "La asistencia al comerciante puede aumentar la exposición del producto",
  累计助力越高推荐权重越高:
    "Cuanto mayor sea la asistencia acumulada, mayor será el peso de la recomendación.",
  实时助力动态: "Dinámica de asistencia en tiempo real",
  助力奖励: "Aumentar las recompensas",
  随机奖励金额已生成: "Se ha generado una cantidad de recompensa aleatoria",
  开心收下: "Feliz de aceptarlo",
  助力已结束: "La ayuda ha terminado",
  助力成功: "Ayuda al éxito",
  成功: "éxito",
  进行中: "En progreso",
  等待: "espera",
  助力失败: "La ayuda falló",
  任務: "Tarea",
  下单失败_请稍后重试: "Fallo del pedido, por favor inténtelo más tarde",
  任务: "Tarea"
};
